/**
 *
 * @module mediaPlayheadStatus
 *
 */

import Services from './../services/entry';

/**
 *
 * @enum
 * @extends {SDK.Services.Media.MediaPlayheadStatus}
 * @since 2.0.0
 *
 */
export default Object.assign({}, Services.Media.MediaPlayheadStatus);



// WEBPACK FOOTER //
// ./src/media/mediaPlayheadStatus.js